(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["sv-product-specs"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('sv-product-specs')) {
    customElements.define(
      'sv-product-specs',
      class extends HTMLElement {
        connectedCallback() {
          this.querySelectorAll('[data-sv-dialog-open]').forEach((button) => {
            button.addEventListener('click', () => {
              const dialog = this.querySelector(`[data-sv-dialog="${button.dataset.svDialogOpen}"]`);
              dialog?.showModal();
              dialog?.querySelector('input, button')?.focus();
            });
          });

          this.querySelectorAll('[data-sv-dialog-close]').forEach((button) => {
            button.addEventListener('click', () => button.closest('dialog')?.close());
          });

          this.querySelectorAll('dialog').forEach((dialog) => {
            dialog.addEventListener('pointerdown', (event) => {
              if (event.target === dialog) dialog.close();
            });
          });

          this.querySelector('[data-sv-size-form]')?.addEventListener('submit', (event) => {
            event.preventDefault();
            this.recommendSize(new FormData(event.currentTarget));
          });
        }

        recommendSize(formData) {
          const height = Number(formData.get('height'));
          const weight = Number(formData.get('weight'));
          const fitAdjustment = Number(formData.get('fit'));
          if (!height || !weight) return;

          const sizeOrder = ['XS', 'S', 'M', 'L', 'XL', '2XL', '3XL'];
          const normalizedWeight = weight - (height - 175) * 0.45;
          const thresholds = [58, 67, 78, 90, 103, 118];
          let recommendedIndex = thresholds.findIndex((threshold) => normalizedWeight < threshold);
          if (recommendedIndex === -1) recommendedIndex = sizeOrder.length - 1;
          recommendedIndex = Math.max(0, Math.min(sizeOrder.length - 1, recommendedIndex + fitAdjustment));

          const availableSizes = this.dataset.availableSizes
            .split('|')
            .map((size) => size.trim().toUpperCase().replace('XXXL', '3XL').replace('XXL', '2XL'))
            .filter((size) => sizeOrder.includes(size));

          if (availableSizes.length) {
            const availableIndexes = availableSizes.map((size) => sizeOrder.indexOf(size));
            recommendedIndex = availableIndexes.reduce((closest, current) =>
              Math.abs(current - recommendedIndex) < Math.abs(closest - recommendedIndex) ? current : closest
            );
          }

          const result = this.querySelector('[data-sv-size-result]');
          result.querySelector('[data-sv-size-value]').textContent = sizeOrder[recommendedIndex];
          result.hidden = false;
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
